import type * as React from 'react'

/**
 * Keydown handler that gives a non-`<button>` element with `role="button"` the
 * keyboard activation a real button has: Enter and Space fire `handler`.
 *
 * Keys pressed on a nested control (an action button inside a clickable card)
 * bubble up here too; those are ignored so the inner control isn't shadowed.
 */
export function activateOnKey(handler: () => void) {
  return (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.target !== e.currentTarget) return
    if (e.key !== 'Enter' && e.key !== ' ') return
    // Space would otherwise scroll the page.
    e.preventDefault()
    handler()
  }
}
